const BASE_URL = 'proposals'

export default {
  GET_PROPOSAL: `/${BASE_URL}`,
  GET_PROPOSALS: `/${BASE_URL}`,
}
